import type { FC } from 'react';

import { useAppDispatch, useAppSelector } from 'features/app/hooks';
import { parsePhoneNumberWithRemovePlus } from 'features/call/call-base/helpers';
import { CallDetailsExtensionInput } from 'features/call/call-details/components/CallDetailsExtensionInput/CallDetailsExtensionInput';
import {
  hearingsSelector,
  setHearingPhoneExtension,
} from 'features/call/call-hearing/store';
import { ANONYMOUS } from 'features/voice-meeting/constants';
import { isPrimaryVcoSenderSelector } from 'features/vco/store';

export interface CallDetailsExtensionInputContainerProps {
  phoneNumber: string;
}

export const CallDetailsExtensionInputContainer: FC<
  CallDetailsExtensionInputContainerProps
> = ({ phoneNumber }) => {
  const dispatch = useAppDispatch();
  const hearings = useAppSelector(hearingsSelector);
  const isPrimaryVcoSender = useAppSelector(isPrimaryVcoSenderSelector);

  if (!phoneNumber || phoneNumber === ANONYMOUS) {
    return null;
  }

  const normalizedPhoneNumber = parsePhoneNumberWithRemovePlus(phoneNumber);
  const hearing = hearings.find(
    (participant) =>
      Boolean(participant.phoneNumber) &&
      participant.phoneNumber !== ANONYMOUS &&
      parsePhoneNumberWithRemovePlus(participant.phoneNumber) ===
        normalizedPhoneNumber
  );

  if (!hearing || !hearing.phoneNumber || hearing.phoneNumber === ANONYMOUS) {
    return null;
  }

  const isDisconnected = hearing.status === 'disconnected';
  const canEditExtension = isDisconnected && isPrimaryVcoSender;
  if (!canEditExtension && !hearing.phoneExtension) {
    return null;
  }

  return (
    <CallDetailsExtensionInput
      value={hearing.phoneExtension}
      disabled={!canEditExtension}
      width='full'
      appearance='dark'
      onChange={(phoneExtension) =>
        dispatch(
          setHearingPhoneExtension({
            phoneNumber: hearing.phoneNumber,
            phoneExtension,
          })
        )
      }
    />
  );
};
